import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintMenu } from '../print-menu';
import { Type } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionLayoutType } from '../../enum/dto/section-layout-type.enum';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class CleanPrintMenu extends PrintMenu {
  getThemeClass(): string {
    return 'clean-print-theme';
  }

  getPageTopMargin(): string {
    return '0.5in';
  }

  getPageBottomMargin(): string {
    return '0.5in';
  }

  getPageLeftMargin(): string {
    return '0.5in';
  }

  getPageRightMargin(): string {
    return '0.5in';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  override fixedLocationBadgesPropertyIsWithin(): WithinNameCell | null {
    return WithinNameCell.TitleLine;
  }

  getPriceColumnTitle(col: SectionColumnViewModel): string {
    if (col.sectionLayoutType === SectionLayoutType.Grid) {
      return col.columnTitle;
    } else {
      return super.getPriceColumnTitle(col);
    }
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.PlayfairDisplay.Regular_400,
      FONT.PlayfairDisplay.Medium_500,
      FONT.OpenSans.Regular_400,
      FONT.OpenSans.SemiBold_600
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/nkc2ymb.css';
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }
}
